import React from 'react';
import { Row, Col, Button } from 'antd';
import { Link } from 'dva/router';
import { FormattedMessage } from 'react-intl';
import styles from './styles.less';

const ButtonBar = ({ cancelAction, deleteAction, modal }) => {
  return (
    <Row className={modal && 'text-center'}>
      <Col span={24}>
        <Button type="primary" htmlType="submit" className={styles.btnSubmit}>
          <FormattedMessage id="Common.Save" />
        </Button>
        {
          cancelAction ?
            (typeof cancelAction === 'function' ?
              <Button type="default" onClick={cancelAction} className={styles.btnCancel}>
                <FormattedMessage id="Common.Cancel" />
              </Button>
              :
              <Link to={cancelAction}>
                <Button type="default" className={styles.btnCancel}>
                  <FormattedMessage id="Common.Cancel" />
                </Button>
              </Link>)
            : null
        }
        {
          deleteAction ?
            <Button type="danger" onClick={deleteAction} className={styles.btnRemove}>
              <FormattedMessage id="Common.Remove" />
            </Button>
            : null
        }
      </Col>
    </Row>
  );
};

export default ButtonBar;



// WEBPACK FOOTER //
// ./src/components/ButtonBar/ButtonBar.js